const CREDENTIAL_KEY = "pm_webauthn_credential_id";

function randomBuffer(length = 32) {
  const bytes = new Uint8Array(length);
  window.crypto.getRandomValues(bytes);
  return bytes;
}

function toBase64Url(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window
    .btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function fromBase64Url(base64Url) {
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const binary = window.atob(base64 + padding);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function hasEnrolledFingerprint() {
  return Boolean(localStorage.getItem(CREDENTIAL_KEY));
}

export async function enrollFingerprint() {
  if (!window.PublicKeyCredential || !navigator.credentials) {
    throw new Error("WebAuthn is not supported in this browser.");
  }

  const userId = randomBuffer(16);
  const publicKey = {
    challenge: randomBuffer(32),
    rp: { name: "VaultKey Password Manager" },
    user: {
      id: userId,
      name: "local-user@vaultkey.app",
      displayName: "VaultKey User"
    },
    pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
    authenticatorSelection: {
      authenticatorAttachment: "platform",
      userVerification: "required",
      residentKey: "preferred"
    },
    timeout: 60000,
    attestation: "none"
  };

  const credential = await navigator.credentials.create({ publicKey });
  if (!credential) {
    throw new Error("Fingerprint enrollment was cancelled.");
  }

  const credentialId = toBase64Url(credential.rawId);
  localStorage.setItem(CREDENTIAL_KEY, credentialId);
  return true;
}

export async function fingerprintAuthenticate() {
  if (!window.PublicKeyCredential || !navigator.credentials) {
    throw new Error("WebAuthn is not supported in this browser.");
  }

  const storedId = localStorage.getItem(CREDENTIAL_KEY);
  if (!storedId) {
    throw new Error("No enrolled fingerprint found. Enroll first.");
  }

  const assertion = await navigator.credentials.get({
    publicKey: {
      challenge: randomBuffer(32),
      allowCredentials: [
        {
          id: fromBase64Url(storedId),
          type: "public-key",
          transports: ["internal"]
        }
      ],
      timeout: 60000,
      userVerification: "required"
    }
  });

  if (!assertion) {
    throw new Error("Fingerprint authentication failed.");
  }

  return assertion;
}
